import s from './style.module.scss';
import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
import { ClockCircleOutline, ExclamationCircleOutline } from 'antd-mobile-icons';
import { useEffect, useState } from 'react';
// process_status=[0,0]
// process_status[0]: 第一个推荐项的状态
// process_status[1]: 第二个推荐项的状态
// 0: 未开始
// 1: 进行中
// 2: 已完成
// 3: 失败

const lineImg = require('@/assets/images/usual/dash.webp');
const RecommendProcess = (props) => {
    const { personalized_recommend_process = '' } = props;
    const { label, status, process_status } = personalized_recommend_process;
    const [labelText, setLabelText] = useState('');
    const [allStatus, setAllStatus] = useState(false);
    useEffect(() => {
        if (process_status[0] === 2 && process_status[1] === 2) {
            setAllStatus(2);
            setLabelText('已完成推荐');
        } else {
            if (process_status.includes(3)) {
                setAllStatus(3);
            } else {
                setAllStatus(1);
            }
            setLabelText('正在执行推荐');
        }
    }, [process_status]);
    return (
        <>
            <div className={s['recommend-process-wrap']}>
                <details open={status !== 'end'}>
                    <summary className="flex cursor-pointer select-none list-none items-center whitespace-nowrap pl-2 font-bold text-gray-500">
                        <div className="flex shrink-0 items-center" style={{ fontSize: 16, color: '#333' }}>
                            <svg
                                style={{ width: 20, marginRight: 4 }}
                                className="mr-2 h-3 w-3 transition-transform duration-500 group-open:rotate-90"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                            <span>
                                <span style={{ marginRight: 4 }}> {labelText}</span>
                                <Display show={allStatus !== 2}>{allStatus === 3 ? <ExclamationCircleOutline /> : <ClockCircleOutline />}</Display>
                            </span>
                        </div>
                    </summary>
                    <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 6 }}>
                        <div className={s.think_content}>
                            <div className={s['line']}>
                                <img src={lineImg} alt="" />
                            </div>
                            <div className={s.think_item} data-status={process_status[0]}>
                                <span className={s.think_item_dot} style={{ borderWidth: '2px', width: '8px', height: '8px' }}></span>
                                <span data-text="搜索匹配资源" className={process_status[0] === 1 ? 'loading-text' : ''}>
                                    搜索匹配资源
                                </span>
                                {process_status[0] === 2 && <MyIcon type="icon-aipptduigou" style={{ marginLeft: 4 }} />}
                                {process_status[0] === 3 && <span style={{ marginLeft: 4 }}>!</span>}
                            </div>
                            <div className={s.think_item} data-status={process_status[1]}>
                                <span className={s.think_item_dot} style={{ borderWidth: '2px', width: '8px', height: '8px' }}></span>
                                <span data-text="生成个性化推荐" className={process_status[1] === 1 ? 'loading-text' : ''}>
                                    生成个性化推荐
                                </span>
                                {process_status[1] === 2 && <MyIcon type="icon-aipptduigou" style={{ marginLeft: 4 }} />}
                                {process_status[1] === 3 && <span style={{ marginLeft: 4 }}>!</span>}
                            </div>
                        </div>
                    </div>
                </details>
            </div>
        </>
    );
};
export default RecommendProcess;
